<template>
  <div>
    <!-- <Nav></Nav> -->
    <Nav></Nav>
    <mdb-container class="page-title pt-4">
      <mdb-row class="mb-4">
        <mdb-col md="12" class="text-left">
          <h1 class="mb-1">{{mthSlugToLabel(courseslug)}}</h1>

          <div class="course-discription mb-4">
            <p>{{courseFirebaseData.description}}</p>
          </div>
          <span data-v-8676335a class="lesson-count">
            <!-- <mdb-badge pill color="bg-red" class="ml-0">YOUR MAIN GAP</mdb-badge>
            <ScoreToGapVisualizer :score="1"></ScoreToGapVisualizer>-->
            <mdb-badge pill color="bg-middleGrey" class="ml-0">
              <mdb-icon icon="video" />
            </mdb-badge>
            {{mthGetNumberOfLessonsByCoursename(coursename)}} lessons
          </span>
          <!-- Start Learning, Continue Learning -->
          <mdb-btn
            @click="mthGoToCurrentVideoOrTextInCourse()"
            color="primary"
            class="btn-ssm ml-4"
            rounded
          >{{mthWordStartOrContinueByProgress(coursename)}} Learning</mdb-btn>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <mdb-container class="mb-4 content courses">
      <mdb-row class="my-4">
        <mdb-col md="12">
          <div class="list">
            <template v-for="(item,index2) in courseFirebaseData.newOrEditedCourseDetails">
              <!-- category name -->
              <div v-if="item.type==='category'" class="list-element cat" :key="'cat'+index2">
                <h5>{{item.data}}</h5>
                <div class="ml-auto">
                  <span class>
                    <div @click="mthToggleCategory(item.data)">
                      <mdb-icon icon="angle-down" />
                    </div>
                  </span>
                </div>
              </div>

              <!-- subcategory name -->
              <div
                v-if="item.type==='subcategory' && !collapsedCategoriesNames.includes(mthGetmyCategory2(index2))"
                :key="'subcat'+index2"
                class="list-element subcat"
              >
                <h5>{{item.data}}</h5>
                <div class="ml-auto">
                  <span class>
                    <div @click="mthToggleSubCategory(item.data)">
                      <mdb-icon icon="angle-down" />
                    </div>
                  </span>
                </div>
              </div>

              <!-- video name -->
              <template
                v-if="
                item.type==='video'
                //&& !collapsedSubCategoriesNames.includes(mthGetmySubCategory(item.data.data.name))
                //&& !collapsedCategoriesNames.includes(mthGetmyCategory(mthGetmySubCategory(item.data.data.name),index2))
                && !collapsedCategoriesNames.includes(mthGetmyCategory2(index2))
                "
              >
                <a
                  @click="mthLogIndexAndGoToVideo(item.data.data.vimeoid, index2)"
                  :key="'rl3'+index2"
                >
                  <div :class="mthGetClassByIndex(index2)">
                    <mdb-icon icon="caret-right" />
                    <h5>{{item.data.data.name}}</h5>
                    <div class="ml-auto">
                      <mdb-icon
                        v-if="mthIsThisVideoWatched(item) && vimeoidsToMarkAsWatched.includes(item.data.data.vimeoid)"
                        icon="check"
                        class="check"
                      />
                      <span class="time">{{item.data.data.vimeoduration | timeInHours}}</span>
                    </div>
                  </div>
                </a>
              </template>

              <!-- text -->
              <template
                v-if="
                item.type==='text'
                && !collapsedSubCategoriesNames.includes(mthGetmySubCategory(item.data))
                && !collapsedCategoriesNames.includes(mthGetmyCategory2(index2))
                "
              >
                <a
                  v-if="item.type==='text'"
                  @click="mthLogIndexAndGoToText(index2)"
                  :key="'rl2'+index2"
                >
                  <div :class="mthGetClassByIndex(index2)">
                    <mdb-icon icon="caret-right" />
                    <h5>{{item.title}} {{mthGetmySubCategory(item.title)}}</h5>
                    <div class="ml-auto">
                      <!-- <mdb-icon icon="check" class="check" /> -->
                    </div>
                  </div>
                </a>
              </template>
            </template>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <Footer></Footer>
  </div>
</template>


<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbTbl,
  mdbIcon
} from "mdbvue";
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from "hooper";
import firebase from "firebase/app";
import { courseCatsSubcatsItemsMixin } from "../mixins/CourseCatsSubcatsItemsMixin";
import ScoreToGapVisualizer from "../components/ScoreToGapVisualizer";

export default {
  name: "Course",
  mixins: [courseCatsSubcatsItemsMixin],
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
    mdbTbl,
    mdbIcon,
    ScoreToGapVisualizer
  },
  data() {
    return {
      courses: [],
      progressTrackingOfMine: [], //used for progress presenting
      coursename: "",
      courseslug: "",
      currentindexFromProgressIndicesTracking: 0,
      courseFirebaseData: {},
      yourScore: 0,
      collapsedCategoriesNames: [],
      collapsedSubCategoriesNames: []
    };
  },
  methods: {
    mthLogIndexAndGoToText(index2) {
      this.mthRegisterIndexProgressByEmailSlug(
        index2,
        this.courseslug,
        this.$store.getters.getUser.email
      );
      var link = this.mthConstructLinkToVideoPlayerIfText(index2);
      this.$router.replace(link);
    },
    mthLogIndexAndGoToVideo(vimeoid, index2) {
      var link = this.mthConstructLinkToVideoPlayer(
        vimeoid,
        index2,
        this.courseslug
      );
      this.$router.replace(link);

      this.mthRegisterIndexProgressByEmailSlug(
        index2,
        this.courseslug,
        this.$store.getters.getUser.email
      );
    },
    mthGetClassByIndex(index) {
      // console.log(
      //   "mthGetClassByIndex called",
      //   index,
      //   this.currentindexFromProgressIndicesTracking
      // );

      var ret = "list-element lesson";

      if (index == this.currentindexFromProgressIndicesTracking)
        ret += " active";

      return ret;
    },
    mthFillCurrentindexFromProgressIndicesTracking(slug, email) {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressIndicesTracking")
        .doc(email + "_" + slug)
        .get()
        .then(doc => {
          if (!doc.exists) {
          } else {
            if (doc && doc.data() && doc.data().currentindex) {
              this.currentindexFromProgressIndicesTracking = doc.data().currentindex;
            }
          }
        });
    },
    mthFillProgressTrackingOfMine() {
      var refProgressTracking = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.$store.getters.getUser.email);

      refProgressTracking.onSnapshot(querySnapshot => {
        this.progressTrackingOfMine = [];
        querySnapshot.forEach(doc => {
          this.progressTrackingOfMine.push({
            firedata: doc.data()
          });
        });
        //console.log(this.progressTrackingOfMine);
      });

      return 0.001;
    },
    mthGetFirstLinkableIndexInCourse() {
      for (
        var i = 0;
        i < this.courseFirebaseData.newOrEditedCourseDetails.length;
        i++
      ) {
        //video
        if (this.courseFirebaseData.newOrEditedCourseDetails[i].type == "video")
          return {
            index: i,
            type: this.courseFirebaseData.newOrEditedCourseDetails[i].type,
            vimeoid: this.courseFirebaseData.newOrEditedCourseDetails[i].data
              .data.vimeoid
          };

        //text
        if (this.courseFirebaseData.newOrEditedCourseDetails[i].type == "text")
          return {
            index: i,
            type: this.courseFirebaseData.newOrEditedCourseDetails[i].type,
            vimeoid: "this is text"
          };
      }

      return {
        index: -1,
        type: "not exist",
        vimeoid: "empty"
      };
    },
    mthGoToCurrentVideoOrTextInCourse() {
      //go to details for currentindexFromProgressIndicesTracking
      var currentindexFromProgressIndicesTracking = this
        .currentindexFromProgressIndicesTracking;

      var item = this.courseFirebaseData.newOrEditedCourseDetails[
        currentindexFromProgressIndicesTracking
      ];

      //console.log("item is ", item);

      var link = "";

      var slug = this.coursename
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(".", "")
        .replace(".", "")
        .replace(",", "")
        .replace(",", "");

      if (item && item.type && item.type === "text") {
        link = this.mthConstructLinkToVideoPlayerIfText(
          currentindexFromProgressIndicesTracking
        );
      } else if (item && item.type && item.type === "video") {
        link = this.mthConstructLinkToVideoPlayer(
          item.data.data.vimeoid,
          currentindexFromProgressIndicesTracking,
          slug
        );
      } else {
        var firstLinkableItemInCourse = this.mthGetFirstLinkableIndexInCourse();

        if (firstLinkableItemInCourse.type === "video") {
          link = this.mthConstructLinkToVideoPlayer(
            firstLinkableItemInCourse.vimeoid,
            firstLinkableItemInCourse.index,
            slug
          );
        } else if (firstLinkableItemInCourse.type === "text") {
          link = this.mthConstructLinkToVideoPlayerIfText(first.index);
        }
      }

      //console.log("link is ", link);
      this.$router.replace(link);
    },

    mthWordStartOrContinueByProgress(coursename) {
      var toret = "Start";

      var progress = this.mthGetProgress(coursename);

      //console.log("progress is " + progress);

      if (progress > 1) toret = "Continue";

      return toret;
    },
    mthGetProgress(coursename) {
      var toret = 0.001;

      var licznik = this.mthGetSumOfVideosProgressesByCoursname(coursename);
      var mianownik = this.mthGetCourseTotalMinutesByName(coursename);

      // console.log("licznik=" + licznik);
      // console.log("mianownik=" + mianownik);

      if (mianownik === 0) return 0;
      if (licznik < 5) return 0;

      // console.log("licznik: " + licznik);
      // console.log("mianownik: " + mianownik);

      toret = (licznik * 100) / mianownik;

      if (toret > 100) return 100;
      if (toret < 0) return 0;

      toret = Math.round(toret);

      if (toret > 98) toret = 100;

      return toret;
    },
    mthGetSumOfVideosProgressesByCoursname(coursename) {
      var toret = 0.00000001;

      this.progressTrackingOfMine.forEach(t => {
        //console.log(t.firedata);

        if (t && t.firedata && t.firedata.courseslug && t.firedata.event) {
          let cname = t.firedata.courseslug
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ")
            .replace("-", " ");
          if (cname === coursename && t.firedata.event.seconds)
            toret += t.firedata.event.seconds;
        }
      });

      return toret;
    },
    mthGetCourseTotalMinutesByName(coursename) {
      let totalminutes = 0; //to not divide by 0 ;)
      //console.log('arg is'+coursename)

      this.courses.forEach(c => {
        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          c.firedata.newOrEditedCourseDetails.forEach(d => {
            if (d.type && d.type === "video") {
              if (d && d.data && d.data.data && d.data.data.vimeoduration) {
                totalminutes += d.data.data.vimeoduration;
              }
            }
          });
        }
      });

      return totalminutes;
    },

    mthFillCourses() {
      var refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        this.courses = [];
        querySnapshot.forEach(doc => {
          this.courses.push({
            firedata: doc.data()
          });
        });
        //console.log(this.courses);
      });
    },

    mthGetNumberOfLessonsByCoursename(coursename) {
      var toret = 0;

      this.courses.forEach(c => {
        //console.log(c)

        //var counter = 0;

        if (
          c.firedata.name === coursename &&
          c.firedata.newOrEditedCourseDetails
        ) {
          //toret = c.firedata.newOrEditedCourseDetails.length;

          c.firedata.newOrEditedCourseDetails.forEach(element => {
            if (element.type == "video" || element.type == "text") {
              toret++;
            }
          });
        }
      });
      return toret;
    },

    mthIsThisVideoWatched(item) {
      return false; //undefinite loop !!!

      //console.log(item.data.data.vimeoid);
      // console.log(
      //   "getting " +
      //     this.$store.getters.getUser.email +
      //     "-" +
      //     item.data.data.vimeoid
      // );

      let ret = false;

      let that = this;

      firebase
        .firestore()
        .collection("progressTracking")
        .doc(this.$store.getters.getUser.email + "-" + item.data.data.vimeoid)
        .get()
        .then(doc => {
          if (!doc.exists) {
            // console.log(
            //   "not exists for " + store.getters.getUser.email
            // );
          } else {
            //console.log("exists");

            if (doc.data().vimeoidended) {
              //console.log("will push");

              if (
                !that.vimeoidsToMarkAsWatched.includes(doc.data().vimeoidended)
              )
                that.vimeoidsToMarkAsWatched.push(doc.data().vimeoidended);
            }
          }
        });

      return true;
    },

    mthGetMyScore() {
      firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", this.$store.getters.getUser.email)
        .orderBy("createdAt", "desc")
        .limit(1)
        //.doc(this.$router.currentRoute.params.filledassessmentidrouterparam)
        //.doc(this.$store.getters.getAssessmentIdParam)
        //.doc()
        .get()
        .then(result => {
          var data = {};
          result.forEach(doc => {
            //console.log(doc.data());
            var that = this;
            function skilln(element) {
              return element.skillname == that.coursename;
            }

            var index = doc.data().slides.findIndex(skilln);
            //console.log(index,'color: red');

            if (
              doc &&
              doc.data() &&
              doc.data().pointsarr &&
              doc.data().pointsarr[index] &&
              doc.data().pointsarr[index].points
            ) {
              this.yourScore = doc.data().pointsarr[index].points;
            } else {
              this.yourScore = 0;
            }
          });
        });
    }
  },
  created() {
    this.courseslug = this.$router.currentRoute.params.courseslug;
    this.coursename = this.mthSlugToLabel(this.courseslug);
    this.mthGetMyScore();

    this.mthGetCourseFirebaseDataBySlug(this.courseslug);

    this.mthFillCourses();

    this.mthFillProgressTrackingOfMine();

    this.mthFillCurrentindexFromProgressIndicesTracking(
      this.courseslug,
      this.$store.getters.getUser.email
    );
  }
};
</script>

<style scoped>
@import url("https://use.typekit.net/lel8wuy.css");

.active {
  background-color: red;
}
</style>
